import type { RoleModel } from '@/adapters/apiv1.g';
import type { Role } from '@/types/core/role';
import type { UUID } from '@/utils/uuid';

/**
 * Transform a backend RoleModel to a frontend Role type.
 * Handles snake_case to camelCase conversion and provides safe defaults.
 * @param model - API RoleModel response
 * @returns Role - UI-friendly Role object
 */
export function extractRole(model: RoleModel): Role {
  const withRev = model as RoleModel & { _rev?: number };
  return {
    _rev: withRev._rev,
    roleId: (model.role_id ?? '') as UUID,
    tenantId: (model.tenant_id ?? '') as UUID,
    name: model.name ?? '',
    description: model.description ?? '',
    isSystem: model.is_system ?? false,
    active: model.active ?? false,
    reconciledAt: model.reconciled_at ?? '',
  };
}
